export const environment = {
    production: true,
    appVersion: 'v1.0',
    USERDATA_KEY: 'elly-pos-admin',
    isMockEnabled: false,
    apiUrl: 'https://public.api.ellypos.io',
    searchInputDebounce: 600,
};
